import CMEAdditionalClearingForm from "./_internal/CMEAdditionalClearingForm";
import CMEAccountsForm from "./_internal/CMEAccountsForm";
import CMESchedulesForm from "./_internal/CMESchedulesForm";
import CMESalesCodeForm from "./_internal/CMESalesCodeForm";
import CMESourceForm from "./_internal/CMESourceForm";
import { EntityInfoType } from "../../types/entityInfo.types";

export const EntityInfoCMEAccounts: EntityInfoType = {
  entity: "Cme/Account",
  entityTitle: 'CME Account',
  editForm: CMEAccountsForm,
  canDelete: false,
};

export const EntityInfoCMESalesCode: EntityInfoType = {
  entity: "Cme/SalesCode",
  entityTitle: 'CME Sales Code (all)',
  editForm: CMESalesCodeForm,
  canDelete: false,
};

export const EntityInfoCMESchedules: EntityInfoType = {
  entity: "Cme/CommSchedule",
  entityTitle: 'CME Commission Schedule',
  editForm: CMESchedulesForm,
  deleteLabelSuffix: 'Schedule',
};


export const EntityInfoCMEAdditClearing: EntityInfoType = {
  entity: "Cme/AdditClearing",
  entityTitle: 'CME Additional Clearing',
  editForm: CMEAdditionalClearingForm,
  deleteLabelSuffix: 'Clearing',
};

export const EntityInfoCMESources: EntityInfoType = {
  entity: "Cme/AccountSources",
  entityTitle: 'Account Source',
  editForm: CMESourceForm,
  deleteLabelSuffix: 'Account Source',
};

export function getCMEFormInfo(id: number, type: string) {
  const rowInfo = { id };
  switch (type) {
    case 'Account':
      return { ...rowInfo, ...EntityInfoCMEAccounts };
    case 'Sales Code':
      return { ...rowInfo, ...EntityInfoCMESalesCode };
    case 'Schedule':
      return { ...rowInfo, ...EntityInfoCMESchedules };
    case 'Addit Clearing':
      return { ...rowInfo, ...EntityInfoCMEAdditClearing };
    case 'Source':
      return { ...rowInfo, ...EntityInfoCMESources };
    default:
      return { id: null, editForm: null, entityTitle: null, entity: null };
  }
}
